// web/src/htmx/handlers/network.js

import { openModal } from "../../alpine/utils/dispatcher";

export function handleNetworkError() {
  openModal("network-error");
}
